import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { debounce } from 'utils/common';
import {  useSelector } from 'react-redux';
import {toTitleCase} from "utils/common"

export default function useUniformFilter(pageSettings , setPageSettings) {
    const [searchParams, setSearchParams] = useSearchParams();
    const {
        userData, userDataLoading,     
        department, departmentLoading,
        position, positionLoading
        
    } = useSelector((state) => state.common);

    const [filterLoading, setFilterLoading] = useState(false)
  const [filters, setFilters] = useState([
    {
        key: "search",
        label: "Search term",
        value: searchParams.get("search") || ""
    },    
    {
        key: "position",
        label: "position",
        value: searchParams.get("position") || ""
    },
    {
        key: "gender",
        label: "gender",
        value: searchParams.get("gender") || ""
    },
    {
        key: "status",
        label: "status",
        value: searchParams.get("status") || ""
    },
    {
        key: "expiry_date_after",
        label: "Expiry After",
        value: searchParams.get("expiry_date_after") || ""
    },  
  
   
  ]);

  useEffect(()=>{

    if(!positionLoading && !userDataLoading){
      
        console.log(searchParams, "------searchParams")     

        let selectedDepartment = [...position].find(item=>item.id == searchParams.get("position") || "")
     

    
        let _filters = [
            {
                key: "search",
                label: "Search term",
                value: searchParams.get("search") || ""
            },
            {
                key: "gender",
                label: "gender",
                value: searchParams.get("gender") || ""
            },
            {
                key: "position",
                label: "position",
                value: searchParams.get("position") || ""
            },
            {
                key: "status",
                label: "status",
                value: searchParams.get("status") || ""
            }   
          
          ]
          setFilters(_filters)
    }

 
  },[
    userData,   
    position
  ])

  const handleInputChange = debounce((data, key, make_call=false) => {
    console.log( "FFFF")

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
    selectedFilter['label'] = key
    selectedFilter['value'] = data
    setFilters(_filters)

    if(make_call){

        
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }

  }, 1000)

  const handleFilterChange =  (data, key, make_call=false) => {
    console.log( "AAAA", data)

    let _filters = [...filters]
    let selectedFilter = _filters.find(item=> item.key === key)
   
    selectedFilter['label'] = data?.label || ""
    selectedFilter['value'] = data?.value || ""
    setFilters(_filters)
    console.log(_filters, "-----filtersssss")
    console.log( _filters, "AAAA")
    if(make_call){
        setPageSettings({
            ...pageSettings,
            page:1,
            filters: _filters
    
        })
    }


    
  };

 

  return {
    handleFilterChange,
    filters,   
    filterLoading, setFilterLoading,  
    handleInputChange
  };
}
